import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getNegotiation(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams); // pathname is "/role"
}
export async function createNegotiation(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/negotiation" + pathname, body);
}

export async function updateNegotiation(pathname, queryParams, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/negotiation" + pathname + queryParams, body);
}

export async function completedNegotiation(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).patch("/negotiation" + pathname, body);
}

export async function deleteNegotiation(pathname, queryParams) {
  return await instance({
    baseURL: baseURL,
  }).post("/negotiation" + pathname + queryParams);
}
